import store from '@/state/store'


export default [
  {
    path: '/client',
    name: 'client_home',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/client/clientHome'),
  },
  {
    path: '/client/campaigns',
    name: 'client_campaigns',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['campaign/hasCampaignsData']) {
          await store.dispatch('campaign/getCampaignsData');
        }
        next();
      }
    },
    component: () => import('./views/client/clientCampaigns'),
  },
  {
    path: '/client/campaigns/create',
    name: 'client_campaigns_create',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['campaign/hasCampaignsData']) {
          await store.dispatch('campaign/getCampaignsData');
        }
        next();
      }
    },
    component: () => import('./views/client/clientCreateCampaign'),
  },
  {
    path: '/client/campaigns/:id/:tab?',
    name: 'client_campaigns_show',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['campaign/hasCampaignsData']) {
          await store.dispatch('campaign/getCampaignsData');
        }

        if(routeTo.params.tab === 'posts' && store.state.campaign.postsByCampaign[routeTo.params.id] === undefined) {
          await store.dispatch('campaign/getCampaignPosts', routeTo.params.id);
        }

        return next();
      }
    },
    component: () => import('./views/client/clientShowCampaign'),
  },
  {
    path: '/client/offers-board/:id?',
    name: 'client_offers_board',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        // eslint-disable-next-line no-constant-condition
        if (true || !store.getters['negotiations/hasNegotiationsData']) {
          try {
            store.commit('loader/START_LOADING');
            await store.dispatch('negotiations/getNegotiationsData', 'client');
          } catch (e) {
            // TODO
          } finally {
            store.commit('loader/END_LOADING');
          }
        }
        next();
      }
    },
    component: () => import('./views/client/clientOffersBoard'),
  },
  {
    path: '/client/content-board/:id?',
    name: 'client_content_board',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        // eslint-disable-next-line no-constant-condition
        if (true || !store.getters['scheduled/hasAgreedPostsData']) {
          try {
            store.commit('loader/START_LOADING');
            await store.dispatch('scheduled/getAgreedPostsData');
          } catch (e) {
            // TODO
          } finally {
            store.commit('loader/END_LOADING');
          }
        }
        next();
      }
    },
    component: () => import('./views/client/clientContentBoard'),
  },
  {
    path: '/client/influencers',
    name: 'client_influencers',
    meta: {
      authRequired: true,
      preventScrollIfItIsSameRoute: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['campaign/hasCampaignsData']) {
          await store.dispatch('campaign/getCampaignsData');
        }
        if (!store.getters['search/hasAllInfluencers']) {
          // This is asynchronous call because those values are not necessary
          store.dispatch('search/getAllInfluencers').then(()=>{})
        }

        next();
      }
    },
    component: () => import('./views/client/clientInfluencers'),
  },
  {
    path: '/client/influencers/:id',
    name: 'client_influencer_profile',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['campaign/hasCampaignsData']) {
          await store.dispatch('campaign/getCampaignsData');
        }
        next();
      },
    },
    component: () => import('./views/client/clientInfluencerProfile'),
  },
  {
    path: '/client/cart/:campaignId?',
    name: 'client_cart',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/client/clientCart'),
  },
  {
    path: '/setup-client',
    name: 'setup-client',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {

        if (store.getters['user/setupFinished']) {
          return next({name: store.getters['user/homeRouteName']});
        }

        return next()
      }
    },
    component: () => import('./views/setupClient/setupClient'),
  },
  {
    path: '/client/profile/:tab?',
    name: 'client-profile',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/client/clientProfile'),
  },
  {
    path: '/client/invoices',
    name: 'client-invoices',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['invoices/hasClientInvoices']) {
          await store.dispatch('invoices/getClientInvoicesData');
        }
        next()
      }
    },
    component: () => import('./views/client/clientInvoices'),
  },
]
